export default __webpack_public_path__ + "static/media/placeholder-temporary.5e0f91d7.png";